/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Cook_OnInputs */

const en_session_cook_on = /** @type {(inputs: Session_Cook_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cook on`)
};

const de_session_cook_on = /** @type {(inputs: Session_Cook_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochen am`)
};

/**
* | output |
* | --- |
* | "Cook on" |
*
* @param {Session_Cook_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_cook_on = /** @type {((inputs?: Session_Cook_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Cook_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_cook_on(inputs)
	return en_session_cook_on(inputs)
});